import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  cardsRoot: {
    display: 'flex',
    gap: theme.spacing(3),
  },
}))
